/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_Step_2_TitleInputs */

const es_home_intro_step_2_title = /** @type {(inputs: Home_Intro_Step_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indexa`)
};

const en_home_intro_step_2_title = /** @type {(inputs: Home_Intro_Step_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index`)
};

/**
* | output |
* | --- |
* | "Index" |
*
* @param {Home_Intro_Step_2_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_intro_step_2_title = /** @type {((inputs?: Home_Intro_Step_2_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_Step_2_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_intro_step_2_title(inputs)
	return en_home_intro_step_2_title(inputs)
});
export { home_intro_step_2_title as "home.intro.step_2_title" }